var map = {
	"./load-more-projects.js": "./assets/src/js/partials/load-more-projects.js",
	"./load-more-reference.js": "./assets/src/js/partials/load-more-reference.js",
	"./site-scripts.js": "./assets/src/js/partials/site-scripts.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/src/js/partials sync recursive \\.js$";